// extracted by mini-css-extract-plugin
export default {"sideNavigation":"navigation_sideNavigation__pJdxV","li":"navigation_li__yjWRR","link":"navigation_link__ey3wk"};